import { constants } from "./constants";

// Carica lo stato iniziale dal localStorage (se esiste)
const savedReduxObject = localStorage.getItem("redux_object");

const initialState = {
  isAuthenticated: !!savedReduxObject,
  redux_object: savedReduxObject ? JSON.parse(savedReduxObject) : null,
  error: null,
};

const cleanInitialState = {
  isAuthenticated: false,
  redux_object: null,
  error: null,
};

// aggiorna il localStorage  user - token - team - products
const updateLocalStorage = (reduxObject) => {
  const storageObject = {
    user: reduxObject.user,
    accessToken: reduxObject.accessToken,
    team: reduxObject.team,
    products: reduxObject.products,
  };
  localStorage.setItem("redux_object", JSON.stringify(storageObject));
};

const userReducer = (state = initialState, action) => {
  let updatedReduxObject;

  switch (action.type) {
    case constants.LOGIN_REQUEST:
      return {
        ...state,
        isAuthenticated: false,
        error: null,
      };

    case constants.LOGIN_SUCCESS: {
      const reduxObject = {
        user: action.payload.user,
        accessToken: action.payload.access_token,
        team: action.payload.teams,
        products: action.payload.products,
        practices: action.payload.practices,
      };
      // salva  user - token - team - products
      updateLocalStorage(reduxObject);

      return {
        ...state,
        isAuthenticated: true,
        redux_object: reduxObject,
        error: null,
      };
    }

    case constants.LOGIN_FAILURE:
      return {
        ...state,
        isAuthenticated: false,
        error: JSON.parse(action.payload.error),
      };

    case constants.LOGOUT_SUCCESS:
      localStorage.removeItem("redux_object");
      return cleanInitialState;

    case constants.LOGOUT_FAILURE:
      return {
        ...state,
        isAuthenticated: false,
        error: action.payload.error,
      };

    case constants.PRACTICE_CREATE_SUCCESS:
    case constants.PRACTICE_UPDATE_SUCCESS:
    case constants.PRACTICE_GET_SUCCESS:
      if (state.redux_object) {
        updatedReduxObject = {
          ...state.redux_object,
          practices:
            action.type === constants.PRACTICE_UPDATE_SUCCESS
              ? state.redux_object.practices.map((pr) =>
                  pr.practice_id === action.payload.practice.practice_id
                    ? action.payload.practice
                    : pr
                )
              : action.payload.practices,
        };
        return {
          ...state,
          redux_object: updatedReduxObject,
        };
      }
      return state;

    default:
      return state;
  }
};

export default userReducer;
